// MOBILE-MENU
const openBtn = document.querySelector("#mobile-menu-open-btn");
const closeBtn = document.querySelector("#mobile-menu-close-btn");
const mobileMenu = document.querySelector(".menu-mobile");

// toogle
openBtn.addEventListener("click", (e) => {
  e.preventDefault;
  mobileMenu.classList.toggle("open");

  if (mobileMenu.classList.contains("open")) {
    openBtn.setAttribute("aria-expanded", true);
    openBtn.setAttribute("aria-label", "Cerrar menú de navegación");
  } else {
    openBtn.setAttribute("aria-expanded", false);
    openBtn.setAttribute("aria-label", "Abrir menú de navegación");
  }
});

closeBtn.addEventListener("click", (e) => {
  e.preventDefault;
  mobileMenu.classList.remove("open");
  closeBtn.setAttribute("aria-expanded", false);
});

// SEARCH-BAR
const searchContainer = document.querySelector(".search-feature");
if (searchContainer) {
  const navBar = document.querySelector(".main-nav-container");
  const searchForm = document.querySelector(".search-form");
  const searchField = searchForm.querySelector(".search-field");
  const searchBtn = document.querySelector(".search-btn");

  const activateSearchNav = (e) => {
    e.preventDefault();
    e.stopPropagation();

    navBar.classList.add("search-active");
    searchContainer.classList.add("active");
    searchField.classList.add("active");

    handleSearchSubmit();
  };
  searchBtn.addEventListener("click", activateSearchNav);

  const handleSearchSubmit = () => {
    // remove previous event
    searchBtn.removeEventListener("click", activateSearchNav);

    searchBtn.addEventListener("click", (e) => {
      e.preventDefault();
      if (searchField.value != "") {
        searchForm.submit();
      }
    });
  };
}

// CLIMA
jQuery(document).ready(function () {
  jQuery.ajax({
    type: "post",
    url: wp_ajax_fac.ajaxurl,
    data: {
      action: "get_weather",
    },
    error: function (response) {
      console.error(response);
    },
    success: function (response) {
      const {
        clima,
        icon_name,
        clima_temp
      } = response;

      if (!clima) {
        const climaErrorHtml = `
        <div class="flex items-center gap-x-2">
          <svg class="w-6 h-6 stroke-gray-dark">
            <use xlink:href="#icon-cloud"></use>
          </svg>
          <p class="text-[0.8125rem] pt-0.5 font-bold">Ver Clima</p>
        </div>`;

        jQuery("#weather-container").html(climaErrorHtml);

        return;
      }

      const climaHtml = `
        <div class="flex items-center gap-x-2">
          <svg class="w-6 h-6 stroke-gray-dark">
            <use xlink:href="#icon-${icon_name}"></use>
          </svg>
          <p class="text-[0.8125rem] pt-0.5 font-bold">${clima_temp}º <span class="hidden md:inline font-normal">Bahía Blanca</span></p>
        </div>`;

      jQuery("#weather-container").html(climaHtml);
    }
  });
});

// HORA-FECHA
let d = new Date();
d.toLocaleString("es-AR", { timeZone: "America/Argentina/Buenos_Aires" });

let fac_hora_minutos = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();

let fac_fecha = `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
let fac_hora = `${d.getHours()}:${fac_hora_minutos}`;
jQuery("#info-bar-fecha").text(fac_fecha);
jQuery("#info-bar-hora").text(fac_hora);
jQuery("#mobile-nav-fecha").text(fac_fecha);
jQuery("#mobile-nav-hora").text(fac_hora);

// PUBLICIDADES
// looper las ads con sus datos y llamar al ajax para cargar la imagen correspondiente
// const adEls = document.querySelectorAll("[data-ad]");
//
// if (adEls) {
//   adEls.forEach((adEl) => {
//     // console.log(adEl.dataset);
//     jQuery.ajax({
//       type: "post",
//       url: wp_ajax_fac.ajaxurl,
//       data: {
//         action: "get_ad",
//         adPage: adEl.dataset.adPage,
//         adPlace: adEl.dataset.adPlace,
//         adType: adEl.dataset.adType,
//       },
//       error: function(response) {
//         // console.log(response);
//       },
//       success: function(response) {
//         const { adUrl, adExist, adAnchorId, adPictureEl } = response;
//
//         let adHtml = "";
//
//         // url start
//         if (adUrl) {
//           adHtml += `<a href="${adUrl}" target="_blank" rel="noopener noreferrer" class="relative" ${adExist ? `id="${adAnchorId}"` : ``
//             } aria-label="Publicidad ${adAnchorId}">`;
//         }
//
//         // picture element
//         if (adPictureEl) {
//           adHtml += adPictureEl.join(",").replaceAll(",", "");
//         } else {
//           adHtml += "<p>Publicite aquí</p>";
//         }
//
//         // url end
//         if (adUrl) {
//           adHtml += `</a>`;
//         }
//
//         jQuery(adEl).html(adHtml);
//       },
//     });
//   });
// }
